import { createDomain, sample } from 'effector'
import { getRentalContractSilent } from '~/entities/RentalContract/model'
import { AxiosErrorType, RentalContact } from '~/shared/api'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'

const domain = createDomain('entities.rentalContract.cancelBooking')

type SigningCancelParams = {
  onDrawerClose: () => void
}

export const signingCancel = domain.createEvent<SigningCancelParams>()
export const signingCancelFx = domain.createEffect<
  SigningCancelParams,
  void,
  AxiosErrorType
>({
  handler: async ({ onDrawerClose }) => {
    await RentalContact.signingCancel()
    onDrawerClose()
  },
})

sample({
  clock: signingCancel,
  target: signingCancelFx,
})

sample({
  clock: signingCancelFx.doneData,
  fn: () => {
    return {
      message: 'Бронь отменится в течение нескольких минут!',
      variant: 'success' as const,
    }
  },
  target: [snackbarEnqueued, getRentalContractSilent],
})

sample({
  clock: signingCancelFx.failData,
  fn: (e) => ({
    message: mapMessageErrors(e),
    variant: 'danger' as const,
  }),
  target: snackbarEnqueued,
})
